import { gql } from '@apollo/client';
import { DocumentFragment } from 'approot/shared/graphql/document/document.graphql';

export const studentAssessmentWorksheetsFragment = gql`
  fragment StudentAssessmentWorksheetsFragment on Assessment {
    id
    assessmentDoc {
      id
      documentType
      document {
        ...documentFragment
      }
    }
    basicAssessment {
      id
      documentType
      document {
        ...documentFragment
      }
    }
    summativeAssessment {
      id
      documentType
      document {
        ...documentFragment
      }
    }
    formativeAssessment {
      id
      documentType
      document {
        ...documentFragment
      }
    }
    unitRubric {
      id
      documentType
      document {
        ...documentFragment
      }
    }
    selfAssessment {
      id
      documentType
      document {
        ...documentFragment
      }
    }
    answerSheet {
      id
      documentType
      document {
        ...documentFragment
      }
    }
  }
  ${DocumentFragment}
`;
